// extracted by mini-css-extract-plugin
export default {"DimensionHeader":"DimensionHeader_DimensionHeader__f3RW0"};